/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Input_BlurbInputs */



/**
* | output |
* | --- |
* | "This is where you talk to the assistant. Type a question and press Enter to send. The toolbar below lets you attach files, switch models, and adjust reasoning." |
*
* @param {Uno_Edu_Chat_Input_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_input_blurb = /** @type {((inputs?: Uno_Edu_Chat_Input_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Input_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hier sprechen Sie mit dem Assistenten. Geben Sie eine Frage ein und drücken Sie Enter zum Senden. Über die Symbolleiste darunter können Sie Dateien anhängen, Modelle wechseln und das Reasoning anpassen.")
	return /** @type {LocalizedString} */ ("This is where you talk to the assistant. Type a question and press Enter to send. The toolbar below lets you attach files, switch models, and adjust reasoning.")
});